@import '../../../../ui/gzDialog/view/windowShared.scss';
@import 'apps/webcomponents/src/assets/style-helpers.scss';

:host {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.footer__container {
  @include windowFooter;

  margin-top: auto;
  justify-content: space-between;
}

gz-textarea {
  height: calc(8 * var(--spacer));
}

gz-text {
  color: var(--chart-300-icon-buttons);
}
